module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.be1c541c.woff2";